import { Action, ActionReducerMap } from '@ngrx/store';
import { reduxReset } from './actions/root/root.actions';
import * as fromAccount from './reducers/accounts/accounts.reducer';
import * as fromCards from './reducers/cards/cards.reducer';
import * as fromDashboard from './reducers/dashboard/dashboard.reducer';
import * as fromMessages from './reducers/messages/messages.reducer';
import * as fromLocations from './reducers/locations/locations.reducer';
import * as fromProfile from './reducers/profile/profile.reducer';
import * as fromTemplates from './reducers/templates/templates.reducer';
import * as fromCrm from './reducers/crm/crm.reducer';
import * as fromOrders from './reducers/orders/orders.reducer';

export interface AppState {
  [fromDashboard.dashboardFeatureKey]: fromDashboard.State;
  [fromAccount.accountFeatureKey]: fromAccount.State;
  [fromCards.cardsFeatureKey]: fromCards.State;
  [fromProfile.profileFeatureKey]: fromProfile.State;
  [fromTemplates.templatesFeatureKey]: fromTemplates.State;
  [fromMessages.messagesFeatureKey]: fromMessages.State;
  [fromLocations.locationsFeatureKey]: fromLocations.State;
  [fromOrders.ordersFeatureKey]: fromOrders.State;
  [fromCrm.crmFeatureKey]: fromCrm.State;
}

export const reducers: ActionReducerMap<AppState> = {
  [fromDashboard.dashboardFeatureKey]: fromDashboard.reducer,
  [fromAccount.accountFeatureKey]: fromAccount.reducer,
  [fromCards.cardsFeatureKey]: fromCards.reducer,
  [fromProfile.profileFeatureKey]: fromProfile.reducer,
  [fromTemplates.templatesFeatureKey]: fromTemplates.reducer,
  [fromMessages.messagesFeatureKey]: fromMessages.reducer,
  [fromLocations.locationsFeatureKey]: fromLocations.reducer,
  [fromOrders.ordersFeatureKey]: fromOrders.reducer,
  [fromCrm.crmFeatureKey]: fromCrm.reducer
};

export const clearState = (reducer: any) => {
  return (state: AppState | undefined, action: Action) => {
    if (action.type === reduxReset().type) {
      state = undefined;
    }

    return reducer(state, action);
  };
};
